const routes = [
    {
        path: "/coop/cooper",
        component: () => import("../pages/Index.vue"),
        meta: {
            isAuthenticated: true,
            permission: "coopinternshipapplication_approvedindex",
        }
    }
];

export default routes;
